import { useOrgContext } from 'components/OrgContextProvider';
import React from 'react';

export default function TenantHome() {
	const ctx = useOrgContext();

	if (!ctx?.tenantID) {
		return <p>Select a tenant from the selector above to view tenant details.</p>;
	}

	if (!ctx?.workspaceID) {
		if (ctx?.tenant && ctx.tenant.workspaces && ctx.tenant.workspaces.length > 0) {
			ctx.changeContext(ctx.tenantID, ctx.tenant.workspaces[0].id);
		}
	}

	return (
		<div>
			<h2>{ctx?.tenant?.name}</h2>
			<p>Welcome to the tenant home page. Please select a workspace from the selector above to continue.</p>
		</div>
	);
}